import GlobalPortal from '@/components/commons/GlobalPortal';
import useUI from '@/components/hooks/useUI';

import Toast from '.';

import styled from 'styled-components';

const TOAST_CONTAINER_BASE_CLASSNAME = 'spendit-toast-container';

export const ToastContainer = () => {
  const { toasts } = useUI();

  return (
    <GlobalPortal>
      <ToastList className={TOAST_CONTAINER_BASE_CLASSNAME}>
        {toasts.map(toast => (
          <Toast key={toast.id} {...toast} />
        ))}
      </ToastList>
    </GlobalPortal>
  );
};

const ToastList = styled.div`
  position: fixed;
  bottom: 24px;
  left: 24px;
  width: 420px;
  z-index: 9999;
`;
